interface DragOverlayOptions {
    element?: HTMLElement;
    fallbackText?: string;
    fallbackBackground?: string;
    borderColor?: string;
    paddingX?: number;
    paddingY?: number;
}

export async function createDragOverlay(options: DragOverlayOptions = {}): Promise<HTMLElement> {
    const {
        element,
        fallbackText = "Drag Item",
        fallbackBackground = "#F3F4F6",
        borderColor = "#2A79F3",
        paddingX = 0,
        paddingY = 8,
    } = options;

    const container = document.createElement("div");
    container.style.cssText = `
        position: fixed;
        top: -1000px;
        left: -1000px;
        background: white;
        border: 2px solid ${borderColor};
        border-radius: 8px;
        z-index: 10000;
        pointer-events: none;
        overflow: hidden;
        padding: 8px;
        opacity: 1;
    `;

    const thumbnailContainer = document.createElement("div");
    thumbnailContainer.style.cssText = `
        width: 100%;
        height: 100%;
    `;

    if (element) {
        const clone = element.cloneNode(true) as HTMLElement;
        clone.style.pointerEvents = "none";
        const elementRect = element.getBoundingClientRect();
        container.style.width = `${elementRect.width + paddingX}px`;
        container.style.height = `${elementRect.height + paddingY}px`;
        thumbnailContainer.appendChild(clone);
    } else {
        const fallback = document.createElement("div");
        fallback.style.cssText = `
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${fallbackBackground};
            border-radius: 8px;
            color: #6B7280;
            font-size: 14px;
            font-weight: 500;
        `;
        fallback.textContent = fallbackText;
        thumbnailContainer.appendChild(fallback);
    }

    container.appendChild(thumbnailContainer);
    document.body.appendChild(container);

    return container;
}

export function setupDragStart(
    event: DragEvent,
    data: any,
    element?: HTMLElement,
    options: Omit<DragOverlayOptions, "element"> = {}
): Promise<void> {
    return new Promise((resolve) => {
        if (!event.dataTransfer) {
            resolve();
            return;
        }

        createDragOverlay({ ...options, element }).then((dragOverlay) => {
            if (!event.dataTransfer) {
                resolve();
                return;
            }

            event.dataTransfer.setDragImage(dragOverlay, 100, 50);

            event.dataTransfer.setData("new-easypage-section", JSON.stringify(data));
            event.dataTransfer.effectAllowed = "copy";

            // Clean up the overlay after a short delay
            setTimeout(() => {
                if (dragOverlay.parentNode) {
                    dragOverlay.parentNode.removeChild(dragOverlay);
                }
            }, 100);

            resolve();
        });
    });
}
